
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Clock, CheckCircle } from "lucide-react";

const FeatureCTA = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-20 bg-gradient-to-br from-accent/10 to-primary/5">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-6">
          Ready to Simplify Your Business?
        </h2>
        
        <p className="text-xl text-secondary/80 max-w-3xl mx-auto mb-10 leading-relaxed">
          Join thousands of owners who have streamlined their operations with Hivetivity.
        </p>
        
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-10">
          <div className="flex items-center text-secondary">
            <Clock className="mr-2 h-5 w-5 text-primary" />
            <span>Set up in minutes, not days</span>
          </div>
          
          <div className="hidden md:block h-5 w-px bg-border mx-4"></div>
          
          <div className="flex items-center text-secondary">
            <CheckCircle className="mr-2 h-5 w-5 text-primary" />
            <span>14-day free trial, no credit card required</span>
          </div>
        </div>
        
        <Button 
          className="text-lg py-6 px-8 shadow-md hover:shadow-lg transition-all duration-300 bg-primary text-primary-foreground hover:bg-primary/90"
          onClick={() => navigate("/business-trial")}
        >
          Start Your Free Trial
        </Button>
        
        <p className="mt-4 text-sm text-secondary/70">
          14-day trial. No credit card required.
        </p>
      </div>
    </section>
  );
};

export default FeatureCTA;
